import type { ColumnType } from 'antd/es/table';

import { ESchoolTypeToText, SCHOOL_TYPE_TO_TEXT_MAPPER } from '../consts';

import { OptionsCell } from './_components/OptionsCell/OptionsCell';
import { StatusTag } from './_components/StatusTag/StatusTag';
import type { IUnpublishModalSchoolInfo } from './_components/UnpublishSchoolModal/types';
import type { TTableData } from './types';

export const getSchoolTableColumns = ({
  openUnpublishModalCb,
  setCurrentSchoolInfoCb,
}: {
  openUnpublishModalCb: VoidFunction;
  setCurrentSchoolInfoCb: (data: IUnpublishModalSchoolInfo) => void;
}) =>
  [
    {
      title: 'Название школы',
      dataIndex: 'name',
      key: 'name',
      ellipsis: true,
    },
    {
      title: 'Тип школы',
      dataIndex: 'school_type',
      key: 'school_type',
      width: 150,
      render: (_, record) => SCHOOL_TYPE_TO_TEXT_MAPPER[record.school_type],
    },
    {
      title: 'Статус',
      dataIndex: 'active',
      key: 'active',
      width: 200,
      render: (_, record) => <StatusTag isPublished={record.active} />,
      filters: [
        {
          text: ESchoolTypeToText.Published,
          value: true,
        },
        {
          text: ESchoolTypeToText.UnPublished,
          value: false,
        },
      ],
      onFilter: (value, record) => record.active === value,
      ellipsis: true,
    },
    {
      title: '',
      dataIndex: 'options',
      key: 'options',
      width: 64,
      render: (_, { id, name, active, school_type }) => (
        <OptionsCell
          openUnpublishModalCb={() => {
            setCurrentSchoolInfoCb({
              id,
              name,
            });
            openUnpublishModalCb();
          }}
          isSchoolActive={active}
          id={id}
          schoolType={school_type}
        />
      ),
      fixed: 'right',
    },
  ] as ColumnType<TTableData>[];
